import { Checkbox, Grid, Image } from "@mantine/core";
import {
  ESectionDivider,
  ETextInput,
  ECheckBox,
  ESelect,
  ELabelView,
  ENumberInput,
  ETextArea,
} from "../../../../../../libs/ui";
import useDyspepsiaSymptoms from "../hooks/useDyspepsiaSymptoms";

export default function DyspepsiaSymptoms() {
  const {
    stoolFreq,
    setStoolFreq,
    bristolStoolScore,
    setBristolStoolScore,
    symptomsOfDyspepsia,
    setSymptomsOfDyspepsia,
    dyspepsiaScoringIndex,
    setDyspepsiaScoringIndex,
    finalLeadScoreForDyspepsia,
    scoringIndex,
    errors,
    validateField,
  } = useDyspepsiaSymptoms();

  return (
    <div>
      <ESectionDivider
        title="Dyspepsia Symptoms"
        subTitle="Symptoms of dyspepsia"
      />
      <div className="flex flex-col">
        {symptomsOfDyspepsia?.map((each, index) => (
          <div className="flex gap-3 justify-between">
            <Checkbox
              size="md"
              className="mt-4"
              checked={each?.selected}
              label={each?.label}
              onChange={() => {
                let temp = [...symptomsOfDyspepsia];
                if (temp[index].selected) {
                  temp[index].remarks = "";
                }
                temp[index].selected = !temp[index].selected;
                setSymptomsOfDyspepsia(temp);
              }}
            />
            {each?.selected ? (
              <ETextInput
                size="xs"
                className="w-1/2 pt-2"
                placeholder={
                  each?.label.includes("≥")
                    ? "Exact ___ months"
                    : "Enter Remarks"
                }
                value={each?.remarks}
                onChange={(e) => {
                  let temp = [...symptomsOfDyspepsia];
                  temp[index].remarks = e.target.value;
                  setSymptomsOfDyspepsia(temp);
                }}
              />
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>

      <ESectionDivider
        title="Dyspepsia Symptoms"
        subTitle="Dyspepsia Scoring Index"
        end={
          <p className="text-slate-500 text-sm">
            Final Lead Score:
            <span className="text-base text-slate-600">
              {" "}
              {finalLeadScoreForDyspepsia
                ? +finalLeadScoreForDyspepsia > 15
                  ? "Severe"
                  : +finalLeadScoreForDyspepsia > 8
                    ? "Moderate"
                    : +finalLeadScoreForDyspepsia > 4
                      ? "Mild"
                      : "Very mild"
                : ""}
            </span>
          </p>
        }
      />
      <div className="flex flex-wrap">
        {dyspepsiaScoringIndex?.map((each, index) => (
          <div className="flex items-end justify-between px-3 mb-3 w-1/2 gap-3">
            <Checkbox
              size="md"
              key={index}
              checked={each?.selected}
              label={each?.label}
              onChange={() => {
                let temp = [...dyspepsiaScoringIndex];
                if (temp[index].selected) {
                  temp[index].score = "";
                }
                temp[index].selected = !temp[index].selected;
                setDyspepsiaScoringIndex(temp);
              }}
            />
            {each?.selected ? (
              <ESelect
                size="xs"
                className="w-1/3"
                data={scoringIndex.map((item) => ({
                  label: item.label,
                  value: item.score,
                }))}
                placeholder="Select"
                value={each?.score}
                onChange={(e) => {
                  let temp = [...dyspepsiaScoringIndex];
                  temp[index].score = e || "";
                  setDyspepsiaScoringIndex(temp);
                }}
              />
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
      <ESectionDivider title="Bristol stool score" />
      <div className="flex justify- gap-16">
        <Image
          src={require("../../../../../../assets/images/Bristol-stool.jpeg")}
          alt="bristol stool score"
          h={400}
          //  w={800}
          fit="fill"
        />
        <div>
          <ETextInput
            label="Stool frequency (Per week)"
            placeholder="Stool frequency (In last one week)"
            value={stoolFreq}
            onChange={(e) => setStoolFreq(e?.target?.value)}
          />
          <div className="flex gap-2">
            <ETextInput
              label="Usual Score"
              placeholder="Usual Score"
              allowOnlyNumbers
              error={errors?.bristol_stool_score?.usual || ""}
              value={bristolStoolScore?.usual}
              onChange={(e) => {
                setBristolStoolScore({
                  ...bristolStoolScore,
                  usual: e?.target.value,
                });
                validateField("bristol_stool_score", "usual", e?.target.value, { label: "Usual Score" });
              }}
            />
            <ETextInput
              label="Worst Score"
              placeholder="worst Score"
              allowOnlyNumbers
              error={errors?.bristol_stool_score?.worst || ""}
              value={bristolStoolScore?.worst}
              onChange={(e) => {
                setBristolStoolScore({
                  ...bristolStoolScore,
                  worst: e?.target.value,
                });
                validateField("bristol_stool_score", "worst", e?.target.value, { label: "Worst Score" });
              }}
            />
          </div>

        </div>
      </div>
    </div>
  );
}
